import React from 'react';
import {
  Box,
  Typography,
  Link,
  Paper,
  Divider,
  ListItem,
  List,
  ListItemText,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const DeliveryPolicy = () => {
  return (
    <Box>
      <Typography variant="homePageBody" paragraph>
        At{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>
          <b>KaliyugAi</b>
        </span>{' '}
        we provide <b>digital astrology services</b>, <b>AI-powered insights</b>
        . Since all our offerings are <b>intangible and delivered online</b>,
        there is no physical shipping involved.
      </Typography>
      <Typography variant="h2">1. How Services Are Delivered</Typography>
      <Typography variant="homePageBody" paragraph>
        Our platform works on a <b>token-based model</b>.
        <br />
        After purchasing tokens, users can enter their{' '}
        <b>Date of Birth, Place of Birth, and Time of Birth,</b> and then ask
        questions.
        <br />
        The <b>AI system processes these inputs in real time</b> and provides
        answers instantly, based on Vedic astrology principles.
        <br />
        Since services are delivered digitally and instantly, no shipping or
        manual delivery is required.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        2. Delivery Timelines
      </Typography>
      <Typography variant="homePageBody" paragraph>
        <b>AI Responses</b>: Generated immediately within the chat interface
        after the question is asked.
        <br />
        There are <b>no waiting periods</b> or scheduled deliveries.
        <br />
        In case of a rare technical glitch, answers may be delayed, and users
        are advised to retry or <b>contact support</b>
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        3. Non-Delivery Situations
      </Typography>
      <Typography variant="homePageBody" paragraph>
        Incorrect or incomplete birth details entered by the user may lead to
        inaccurate or failed results.
        <br />
        Service may be temporarily unavailable due to{' '}
        <b>server downtime or technical issues.</b>
        <br />
        In such cases, users can reach out to our support team, and we will
        assist in restoring access.
      </Typography>
      <Typography variant="h2" sx={{ marginTop: '100px' }}>
        4. Support
      </Typography>
      <Typography
        variant="homePageBody"
        paragraph
        sx={{ marginBottom: '243px' }}
      >
        For delivery or service access concerns, please contact:
        <br /> 📧{' '}
        <Link href="mailto:support@kaliyugai.com" color="secondary">
          <b>support@kaliyugai.com</b>
        </Link>
        <br />
        Our team will respond within 24–48 hours.
        <br />
      </Typography>
      {/* <Typography variant='h5' paragraph >
          Additional Shipping Details
          <br/>
          For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 0-7 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. KALIYUGAI ASTROTECH PRIVATE LIMITED is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 0-7 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on 8920320942 or support@kaliyugai.com
          </Typography> */}
    </Box>
  );
};

export default DeliveryPolicy;
